// extracted by mini-css-extract-plugin
export default {"game-settings":"GameSettings_game-settings__aRgMt"};